import { render, staticRenderFns } from "./mediaData.vue?vue&type=template&id=080c9ee0&scoped=true&"
import script from "./mediaData.vue?vue&type=script&lang=js&"
export * from "./mediaData.vue?vue&type=script&lang=js&"
import style0 from "./mediaData.vue?vue&type=style&index=0&id=080c9ee0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "080c9ee0",
  null
  
)

export default component.exports